import {useTheme} from "@mui/material";
import {ID_DISMISSED, ID_DRAFT, ID_READY} from "./SubscriptionsStatuses";


export const useSubscriptionColors= () => {
    const theme = useTheme();
    const getSubscriptionColors = (status: string) => {
        switch (status) {
            case ID_READY:
                return theme.palette.success.transparent;
            case ID_DISMISSED:
                return theme.palette.error.transparent;
            case ID_DRAFT:
                return theme.palette.warning.transparent;
        }
    };

    return {
        getSubscriptionColors
    }

}